import styled from '@emotion/styled'

export const StyleOtpWrapper = styled.div`
  display: flex;
  column-gap: 15px;
  justify-content: center;
`

export const StyleOtpInput = styled.input<any>`
  border: 1px solid ${(props) => props.theme.colors.secondary};
  border-radius: 6px;
  outline: none;
  width: 40px;
  height: 40px;
  text-align: center;
  font-size: 14px;
`

export const StyleResendWrapper = styled.div`
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  column-gap: 5px;
`
export const StyleDidReceivedText = styled.p`
  font-size: 12px;
  color: ${(props: any) => props.theme.colors.text};
`

export const StyleResendText = styled.p`
  font-size: 12px;
  cursor: pointer;
  color: ${(props: any) => props.theme.colors.secondary};
`
